import React from "react"
import { Router } from "@reach/router"
import Page from "../../components/embedded/page"
import { GlobalStateProvider } from "../../components/general/globalState"


const App = () => {

    return (
        <GlobalStateProvider>
            <Router>
                <Page path="embedded/:asset/:id" />
            </Router>
        </GlobalStateProvider>
    )
}
export default App